import { useParams } from "react-router-dom";

export const Details = () => {
  const { market_id } = useParams<{ market_id: string }>();

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">Prediction Market 詳細ページ</h1>
      <p className="mt-2">Market ID: {market_id}</p>
    </div>
  );
};
